import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import logoImg from "../assetes/Suite Logo.png";
import { LuInstagram } from "react-icons/lu";
import { ImFacebook2 } from "react-icons/im";
import { FaTiktok } from "react-icons/fa6";
import { fetchImage } from '../redux/slices/PagesSlice';
import { Link } from 'react-router-dom';
import ImageModal from './ImageModal';

const Footer = () => {
  const dispatch = useDispatch();
  const [isVisible, setIsVisible] = useState(false);
  const { images, loading, error } = useSelector((state) => state.images);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [visibleImages] = useState(6);

  useEffect(() => {
    dispatch(fetchImage());
  }, [dispatch]);

  const handleImageClick = (index) => {
    setCurrentImageIndex(index);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleNext = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const handlePrev = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const newYear = new Date().getFullYear();

  const toggleVisibility = () => {
    window.pageYOffset > 300 ? setIsVisible(true) : setIsVisible(false);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <footer className="bg-[#f8f8f8] text-gray-800 py-12 z-[0] border-t border-[#e7e7e7]">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 lg:gap-12">
          {/* Logo and Contact Section */}
          <div className="text-center md:text-left space-y-4">
            <div className="flex justify-center md:justify-start">
              <Link to="/">
                <img 
                  src={logoImg} 
                  alt="Hamam Logo" 
                  className="w-40 md:w-48 hover:opacity-90 transition-opacity"
                />
              </Link>
            </div>
            
            <div className="space-y-2">
              <p className="text-[#a6741c] font-semibold text-sm">Hofkamp 17</p>
              <p className="text-[#a6741c] font-semibold text-sm">42103 Wuppertal</p>
              <a href="tel:+49020274757400" className="text-[#a6741c] font-semibold text-sm hover:text-[#8a6217] transition-colors block">
  Telefon: 0202 / 747 574 00
</a>
<a href="mailto:info@o-hamamwuppertal.de" className="text-[#a6741c] font-semibold text-sm hover:text-[#8a6217] transition-colors block mt-1">
  E-Mail: info@o-hamamwuppertal.de
</a>
            </div>

            <div className="flex justify-center md:justify-start space-x-4">
              <Link 
                to="https://www.instagram.com/hamam_wuppertal" 
                target="_blank"
                className="text-[#a6741c] hover:text-[#8a6217] transition-colors"
              >
                <LuInstagram className="text-2xl" />
              </Link>
              <Link 
                to="https://www.facebook.com/share/14FtJxxQ8m/" 
                target="_blank"
                className="text-[#a6741c] hover:text-[#8a6217] transition-colors"
              >
                <ImFacebook2 className="text-2xl" />
              </Link>
              <Link 
                to="https://www.tiktok.com/@hamam.wuppertal" 
                target="_blank"
                className="text-[#a6741c] hover:text-[#8a6217] transition-colors"
              >
                <FaTiktok className="text-2xl" />
              </Link>
            </div>
          </div>

          {/* Important Links Section */}
          <div className="text-center md:text-left">
            <h3 className="text-xl font-bold text-[#a6741c] mb-4 tracking-wide">Wichtige Links</h3>
            <ul className="space-y-3">
              {[
                ['AGB', '/condition'],
                ['Hausordnung', '/laws'],
                ['Datenschutz', '/information'],
                ['Impressum', '/owners'],
                ['Kontakt', '/contact']
              ].map(([title, url]) => (
                <li key={title}>
                  <Link 
                    to={url} 
                    className="text-[#a6741c] text-sm font-medium hover:text-[#8a6217] transition-colors"
                  >
                    {title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Opening Hours Section */}
          <div className="text-center md:text-left">
            <h3 className="text-xl font-bold text-[#a6741c] mb-4 tracking-wide">Öffnungszeiten</h3>
            <div className="space-y-2">
              <p className="text-[#a6741c] font-semibold text-sm">Täglich</p>
              <p className="text-[#a6741c] font-semibold text-sm">09:00 - 23:00 Uhr</p>
            </div>
          </div>

          {/* Gallery Section */}
          <div className="text-center">
            <h3 className="text-xl font-bold text-[#a6741c] mb-4 tracking-wide">Galerie</h3>
            <div className="grid grid-cols-3 gap-3 md:grid-cols-2 lg:grid-cols-3">
              {loading && <p className="col-span-3 text-gray-500">Laden...</p>}
              {error && <p className="col-span-3 text-red-500">Fehler: {error}</p>}
              {images?.slice(0, visibleImages).map((img, index) => (
                <div 
                  key={index}
                  className="aspect-square overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-shadow cursor-pointer"
                  onClick={() => handleImageClick(index)}
                >
                  <img 
                    src={img} 
                    alt={`Gallery ${index}`}
                    className="w-full h-full object-cover hover:scale-105 transition-transform"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="mt-12 pt-8 border-t border-[#e7e7e7] text-center">
          <p className="text-[#a6741c] text-sm font-medium">
            © {newYear} • OHW Orientalischer Hamam Wuppertal UG
          </p>
        </div>

        {/* Scroll to Top Button */}
        {isVisible && (
          <button
            onClick={scrollToTop}
            className="fixed bottom-8 right-8 bg-[#a6741c] p-3 rounded-full shadow-lg hover:bg-[#8a6217] transition-colors"
            aria-label="Nach oben scrollen"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 10l7-7m0 0l7 7m-7-7v18"
              />
            </svg>
          </button>
        )}

        {/* Image Modal */}
        {isModalOpen && (
          <ImageModal
            images={images}
            currentIndex={currentImageIndex}
            onClose={handleCloseModal}
            onNext={handleNext}
            onPrev={handlePrev}
          />
        )}
      </div>
    </footer>
  );
};

export default Footer;